import { CLASSES, ARIAS, ATTRIBUTES } from '../utils/constants';
import renderMinicart from '../lib/renderMinicart';
import trapFocus from '../utils/trapFocus';

const initMinicart = () => {
  const minicartToggle = document.querySelector('[data-minicart-toggle]');
  const minicart = document.querySelector('[data-minicart]');
  const minicartCloseBtn = minicart?.querySelector('[data-minicart-close]');
  const minicartOverlay = document.querySelector('[data-minicart-overlay]');

  if (!minicartToggle || !minicart) return;

  const setMinicartState = (minicart, isOpen) => {
    minicart.classList.toggle(CLASSES.MINICART_OPEN, isOpen);
    minicart.toggleAttribute(ATTRIBUTES.INERT, !isOpen);
    minicartToggle.setAttribute(ARIAS.EXPANDED, isOpen);
    minicart.classList.toggle(CLASSES.TRANSLATE_X_0, isOpen);
    minicart.classList.toggle(CLASSES.TRANSLATE_X_100, !isOpen);
  };

  const open = () => setMinicartState(minicart, true);
  const toggle = (evt) => {
    evt.preventDefault();
    const isOpen = minicart.classList.contains(CLASSES.MINICART_OPEN);
    setMinicartState(minicart, !isOpen);
    if (isOpen) {
      minicartToggle.focus();
    } else {
      minicartCloseBtn?.focus();
    }
  };

  minicartToggle.addEventListener('click', toggle);
  minicartCloseBtn?.addEventListener('click', toggle);
  minicartOverlay?.addEventListener('click', toggle);
  minicart.addEventListener('keydown', (evt) => {
    if (evt.key === 'Escape' && minicart.classList.contains(CLASSES.MINICART_OPEN)) toggle(evt);
  });
  trapFocus(minicart);

  window.theme.minicart = { open };

  renderMinicart();
};

export default initMinicart;
